import { render, staticRenderFns } from "./Bankcardlist.vue?vue&type=template&id=b94a27f2&"
import script from "./Bankcardlist.vue?vue&type=script&lang=js&"
export * from "./Bankcardlist.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports